import { useAppDispatch } from 'src/hooks';
import { useMemo } from 'react';
import {
  createColumnHelper,
  flexRender,
  getCoreRowModel,
  useReactTable,
} from '@tanstack/react-table';
import {
  Header,
  TypeOfTableData,
} from '../../../../pricing-simulator/types/generic-table.model';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Tooltip from '@mui/material/Tooltip';
import './ext-row.scss';
import { toggleVisibleColumns } from '../../../../pricing-simulator/store/pricing-simulator-slice';
declare module '@tanstack/react-table' {
  interface ColumnMeta<TData extends unknown, TValue> {
    className?: string;
    alias?: string;
  }
}

export default function GetExternalHeadersRowComponent(
  columnData: any,
  externalRowWidths: any,
  visibleColumns: any,
  activeHeader: any,
) {
  const appDispatch = useAppDispatch();
  // Memoize the column helper to avoid unnecessary re-creations
  const columnHelper = useMemo(() => createColumnHelper<Header>(), []);
  // Dynamically create columns based on columnData
  const columns = useMemo(() => {
    return columnData?.map((data: any, index: number) => {
      if (!data.is_visible) return null; // Skip invisible columns
      if (externalRowWidths) {
        const headerContent = (
          <div style={{
            width: externalRowWidths[data.alias],
          }}>
            <span className={`header-text ${data.is_info_enable === false ? 'expand-icon-column' : 'info-icon-column'}`}
              onClick={() => {
                if (data.is_info_enable === false) appDispatch(toggleVisibleColumns(data.alias))
              }}
              onKeyDown={(e: { key: string; }) => {
                if (e.key == 'Enter' || e.key == '') {
                  if (data.is_info_enable === false) appDispatch(toggleVisibleColumns(data.alias))
                }
              }}

            >
              <span title={data.alias}>
                {data.alias !== 'legendflag' ? data.alias : ''}
              </span>
              {data.is_info_enable === true ? (
                <Tooltip title={data.info_details}>
                  <InfoOutlinedIcon
                    style={{
                      fontSize: '14px',
                      paddingTop: '0px',
                      marginLeft: '6px'
                    }}
                  />
                </Tooltip>
              ) : null}
              {data.is_info_enable === false && data.alias != 'Sim Results' && data.alias != 'legendflag' ?
                <img
                  src='/static/images/multi-price-expand-icon.svg'
                  className='expand-icon'
                  alt='expand_icon'
                  style={visibleColumns[data.alias] ? {
                    transform: 'rotate(180deg)'
                  } : { transform: 'rotate(0deg)' }}
                /> : null}
            </span>
          </div>
        );

        return columnHelper.display({
          id: data.parent_field || data.order,  // Ensure unique ID
          header: () => (
            <div className="custom-div">
              {headerContent}  {/* Column header content */}
            </div>
          ),
          meta: {
            className:
              data.section === TypeOfTableData.LEGEND_FLAG
                ? 'legend-col'
                : !data.has_border
                  ? 'hide-border-col'
                  : '',
            alias: data.alias,
          },
        });
      }
    }).filter(Boolean);
    // Filter out any null values (for invisible columns)
  }, [columnData, externalRowWidths]);

  // Memoize the empty data
  const data = useMemo(() => [], []);

  // Set up the table with the dynamic columns and empty data
  const table = useReactTable({
    data,
    columns,
    getCoreRowModel: getCoreRowModel(),
  });

  return (
    <>
      {columns && columns.length > 0 &&
        <table className="styled-table">
          <thead>
            {table.getHeaderGroups()?.map((headerGroup) => (
              <tr key={headerGroup.id} className="header-row">
                {headerGroup.headers.map((header, index) => {
                  const isLastColumn = index === headerGroup.headers.length - 1;
                  return (
                    <th
                      key={header.id}
                      colSpan={header.colSpan}
                      className={`${isLastColumn ? 'last simulation-results' : ''} ${header.column.columnDef.meta?.className}`}
                      style={isLastColumn ? {} : { backgroundColor: visibleColumns[activeHeader] && activeHeader === header.column.columnDef.meta?.alias ? '#C7C5FF9E' : '#f2f2f2' }}
                    >
                      {header.isPlaceholder
                        ? null
                        : flexRender(header.column.columnDef.header, header.getContext())}
                    </th>
                  );
                })}
              </tr>
            ))}
          </thead>
          <tbody>
          </tbody>
        </table>
      }
    </>
  );
}